module.exports = __webpack_public_path__ + "img/form-list.cacfb459.svg";